angular.module('picmonicng').directive('uiDynamicTargetSelf', [
  '$state',
  '$rootScope',
  function ($state, $rootScope) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        element.attr('target', '_self');

        $rootScope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams) {
          checkState();
        });

        function checkState() {
          if ($state.current.name) {
            element.removeAttr('target');
          }
        }

        checkState();
      },
    };
  },
]);
